import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function List() {
    const pathFrontEnd = '/people/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}people/delete`,
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetAllPeopleTypes:
            config.endpoints.backend + 'peopletypes/getall',
        endpoint: config.endpoints.backend + 'people/getall'
    };

    const profileFilter = chooseProfileFilter();

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_company_id
                ? {
                      name: 'pdc_company_id',
                      type: 'select',
                      label: 'Empresa',
                      options: [],
                      optionsEndpoint: {
                          endpoint: paths.endpointGetAllCompanies,
                          label: 'corporate_name',
                          value: 'id',
                          params: {
                              filter: {
                                  ...profileFilter
                              }
                          }
                      },
                      validations: {
                          required: false
                      },
                      columnSize: 2
                  }
                : {},
            {
                name: 'pdc_people_type_id',
                type: 'select',
                label: 'Categoria de Pessoa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllPeopleTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'people_type',
                type: 'select',
                options: [
                    { label: 'Física', value: 'F' },
                    { label: 'Jurídica', value: 'J' },
                    { label: 'Terceiro Setor', value: 'T' }
                ],
                label: 'Tipo de pessoa',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Pessoas',
        labelTitleButtonAdd: 'Incluir nova pessoa',
        fieldsShowOnDelete: ['entity_name', 'name'],
        formFilters: !profileFilter.pdc_entity_id ? filters : null,
        filter: {
            ...profileFilter
        },
        showPrintButtons: true,
        columns: [
            {
                name: 'company',
                label: 'Empresa'
            },
            {
                name: 'people_name',
                label: 'Nome'
            },
            {
                name: 'people_registered_type',
                label: 'Categoria de Pessoa'
            },
            {
                name: 'document',
                label: 'CPF/CNPJ'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
